var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      _c("b-col", { staticClass: "form-group", attrs: { sm: "12" } }, [
        !_vm.readonly
          ? _c("label", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("common.security.import_cert")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.readonly
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  inputLabel: _vm.$t("common.security.cert_name"),
                },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
            ],
            1
          )
        : _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-read-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.security.cert_name"),
                  inputValue: _vm.name,
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      !_vm.readonly
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  inputLabel: _vm.$t("common.security.certificate"),
                },
                model: {
                  value: _vm.certificate,
                  callback: function ($$v) {
                    _vm.certificate = $$v
                  },
                  expression: "certificate",
                },
              }),
            ],
            1
          )
        : _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-read-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.security.certificate"),
                  inputValue: _vm.certificate,
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      !_vm.readonly
        ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
            _c("label", { attrs: { for: "security-type" } }, [
              _vm._v("\n      " + _vm._s(_vm.$t("common.type_label"))),
              _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.type,
                    expression: "type",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "security-type" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.type = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("common.security.please_select_a_type"))
                  ),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "CA" } }, [
                  _vm._v(_vm._s(_vm.$t("common.security.ca"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "SMIME" } }, [
                  _vm._v(_vm._s(_vm.$t("common.security.smime"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "SSL" } }, [
                  _vm._v(_vm._s(_vm.$t("common.security.ssl"))),
                ]),
              ]
            ),
          ])
        : _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-read-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.type_label"),
                  inputValue: _vm.type,
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      !_vm.readonly
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "3" } },
            [
              _c("datetime-picker-custom", {
                attrs: {
                  disabled: _vm.readonly,
                  format: "DD/MM/YYYY H:i:s",
                  inputLabel: _vm.$t("common.security.valid_date"),
                  customInputClass: "form-control",
                  customLabelClass: "mb-0",
                  maxLength: 19,
                  placeholderValue: _vm.$t("common.datetime_picker_empty_date"),
                  inputIcon: "fa-solid fa-calendar pl-2",
                },
                model: {
                  value: _vm.startDate,
                  callback: function ($$v) {
                    _vm.startDate = $$v
                  },
                  expression: "startDate",
                },
              }),
            ],
            1
          )
        : _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "3" } },
            [
              _c("form-read-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.security.valid_date"),
                  inputValue: _vm.startDate,
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      !_vm.readonly
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "3" } },
            [
              _c("datetime-picker-custom", {
                attrs: {
                  disabled: _vm.readonly,
                  format: "DD/MM/YYYY H:i:s",
                  inputLabel: _vm.$t("common.security.unvalid_date"),
                  customInputClass: "form-control",
                  customLabelClass: "mb-0",
                  maxLength: 19,
                  placeholderValue: _vm.$t("common.datetime_picker_empty_date"),
                  inputIcon: "fa-solid fa-calendar pl-2",
                },
                model: {
                  value: _vm.endDate,
                  callback: function ($$v) {
                    _vm.endDate = $$v
                  },
                  expression: "endDate",
                },
              }),
            ],
            1
          )
        : _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "3" } },
            [
              _c("form-read-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.security.unvalid_date"),
                  inputValue: _vm.endDate,
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      this.formType !== "add" && !_vm.readonly
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { cols: "4" } },
            [
              _c(
                "b-checkbox",
                {
                  model: {
                    value: _vm.checkboxChangePass,
                    callback: function ($$v) {
                      _vm.checkboxChangePass = $$v
                    },
                    expression: "checkboxChangePass",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.chg_pwd")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.formType !== "add" && !_vm.readonly
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { cols: "4" } },
            [
              _c(
                "b-checkbox",
                {
                  model: {
                    value: _vm.checkboxShowPass,
                    callback: function ($$v) {
                      _vm.checkboxShowPass = $$v
                    },
                    expression: "checkboxShowPass",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.show_password")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.formType !== "add" && !_vm.readonly
        ? _c("b-col", { attrs: { cols: "6" } })
        : _vm._e(),
      _vm._v(" "),
      this.formType === "add"
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.pwd"),
                  inputType: "password",
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
            ],
            1
          )
        : !_vm.readonly && _vm.checkboxChangePass === true
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.pwd"),
                  inputType: _vm.passwordFieldType,
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.formType === "add"
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.security.verif_password"),
                  inputType: "password",
                },
                model: {
                  value: _vm.passwordVerif,
                  callback: function ($$v) {
                    _vm.passwordVerif = $$v
                  },
                  expression: "passwordVerif",
                },
              }),
            ],
            1
          )
        : !_vm.readonly && _vm.checkboxChangePass === true
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.security.verif_password"),
                  inputType: _vm.passwordFieldType,
                },
                model: {
                  value: _vm.passwordVerif,
                  callback: function ($$v) {
                    _vm.passwordVerif = $$v
                  },
                  expression: "passwordVerif",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.readonly
        ? _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  inputLabel: _vm.$t("common.security.cn"),
                },
                model: {
                  value: _vm.cn,
                  callback: function ($$v) {
                    _vm.cn = $$v
                  },
                  expression: "cn",
                },
              }),
            ],
            1
          )
        : _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-read-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.security.cn"),
                  inputValue: _vm.cn,
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      !_vm.readonly
        ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
            _c("label", { attrs: { for: "pod" } }, [
              _vm._v("\n      " + _vm._s(_vm.$t("common.security.pod"))),
              _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.idPod,
                    expression: "idPod",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "pod" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.idPod = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.podList, function (pod) {
                return _c(
                  "option",
                  { key: pod.id, domProps: { value: pod.name } },
                  [_vm._v("\n        " + _vm._s(pod.name) + "\n      ")]
                )
              }),
              0
            ),
          ])
        : _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-read-group-label-input", {
                attrs: {
                  inputLabel: _vm.$t("common.security.pod"),
                  inputValue: _vm.idPod,
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }